export default "__VITE_ASSET__c166caa0__"